import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Autoplay, EffectCoverflow, Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules';
import "swiper/swiper-bundle.css"

import { fetchText } from '../fetch-helper/fetch-helper';
import carouselConfig, { getCarouselConfig } from './carousel-config';

import '../../../css/bem/_component-carousel.scss';
import { waitForFrame } from '../utility-functions/utility-functions';
import carouselThumbs from './carousel-thumbs';
import { SwiperModule } from 'swiper/types/shared';

// configure Swiper to use modules
// Swiper.use([Navigation, Pagination, Autoplay]);

export const swiperModules = [Zoom, Navigation, Pagination, Autoplay, EffectCoverflow, Thumbs] as SwiperModule[];

export default function (context: Document | HTMLElement = document) {
  console.log('Component Carousel Module Loaded');

  context.querySelectorAll<HTMLElement>('.swiper-container:not(.swiper-prevent)').forEach((carousel) => {
    const config = getCarouselConfig(carousel.closest('.component-carousel'), carousel.dataset.config);
    const isAjax = carousel.dataset.url;
    const hasInit = carousel.dataset.hasInitialized;
    const hasThumbs = carousel.closest('.component-carousel')?.hasAttribute('data-thumbs-partner');
    if (hasInit == 'true') return;

    if (isAjax) {
      const prevButton = carousel.querySelector('.carousel-button-prev');
      const nextButton = carousel.querySelector('.carousel-button-next');

      if (prevButton)
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
        });
      if (nextButton)
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          ajaxCarouselSlide(carousel);
          prevButton.classList.remove('swiper-button-disabled');
        });
    } else {
      const swiperInstance = new Swiper(carousel, {
        ...config,
        modules: swiperModules,
        Init: (swiper) => {
          /*  Wouldnt have to do this if we have updated to latest version... */
          if (swiper.slides.length === 1) disablePagination(carousel);
        }
      } as SwiperOptions);

      carousel.dataset.hasInitialized = 'true';
      hasThumbs && carouselThumbs(swiperInstance);
    }
  });
}

const disablePagination = (carousel) => {
  const pagination = carousel.querySelector('.swiper-pagination');
  pagination?.classList.add('hidden');
};

const ajaxCarouselSlide = (carousel) => {
  if (_hasLoadedExtraImages(carousel)) return;

  _loadExtraImages(carousel);
};

const _hasLoadedExtraImages = (carousel) => {
  return carousel.dataset.hasLoaded;
};

const _loadExtraImages = (carousel: HTMLElement) => {
  // Lock to prevent multiple AJAX loads at the same time
  if (carousel.dataset.isLoading === 'true') return;
  carousel.dataset.isLoading = 'true';

  const url = carousel.dataset.url;
  const config = carouselConfig[carousel.dataset.config];
  const carouselImageContainer = carousel.querySelector<HTMLDivElement>('.swiper-wrapper');
  const currentImage = carouselImageContainer.querySelector<HTMLImageElement>('.swiper-slide img');

  carousel.style.height = `${carousel.clientHeight}px`;

  Promise.all([_duplicateOriginalImage(currentImage, carousel), fetchText(url, null)])
    .then(([clonedImage, ajaxResponse]) => {
      carouselImageContainer.innerHTML = ajaxResponse;
      return clonedImage;
    })
    .then(waitForFrame)
    .then(waitForFrame)
    .then(waitForFrame)
    .then((clonedImage: HTMLElement) => {
      const mySwiper = new Swiper(carousel, config);

      clonedImage?.parentNode?.removeChild(clonedImage);
      carousel.dataset.hasLoaded = 'true';
      carousel.dataset.hasInitialized = 'true';

      mySwiper.slideNext();
    })
    .finally(() => {
      // Unlock after initialization completes
      carousel.dataset.isLoading = 'false';
    });
};


const _duplicateOriginalImage = (image: HTMLImageElement, carousel: HTMLElement) => {
  return new Promise((resolve) => {
    const clonedImage = document.createElement('img');
    const src: string = image.getAttribute('src');

    clonedImage.setAttribute('src', src);
    clonedImage.classList.add('component-carousel__temp-ajax-image', 'img-fluid');

    carousel.appendChild(clonedImage);

    clonedImage.addEventListener('load', () => {
      resolve(clonedImage);
    });
  }) as Promise<HTMLImageElement>;
};
